import { IntegrationUpdateBanner } from './IntegrationUpdateBanner'
import MicrosoftIconNoBackground from '@assets/images/microsoft-icon-no-background.svg?react'
import GoogleIconNoBackground from '@assets/images/google-icon-no-background.svg?react'
import { IntegrationSectionContainer } from '../FraudDefenseMarketing.styles'
import MicrosoftIcon from '@assets/images/microsoft-icon.svg?react'
import GoogleIcon from '@assets/images/google-icon.svg?react'
import { useFraudDefenseMarketing } from '../useFraudDefenseMarketing'
import { ProviderActivationCard } from '@/ui/components/ProviderActivationCard'

const IntegrationSection = () => {
    const {
        handleMicrosoftIntegrationClick,
        handleGoogleIntegrationClick,
        handleMsUpdateClick,
        handleGoogleUpdateClick,
        microsoftProvider,
        googleProvider,
        shouldShowMsUpdateBanner,
        shouldShowGoogleUpdateBanner,
        isMicrosoftFraudDefenseLoading,
        isGoogleFraudDefenseLoading,
    } = useFraudDefenseMarketing()

    const shouldShowAnyUpdateBanner =
        shouldShowMsUpdateBanner || shouldShowGoogleUpdateBanner

    if (shouldShowAnyUpdateBanner) {
        return (
            <IntegrationSectionContainer>
                {shouldShowMsUpdateBanner && (
                    <IntegrationUpdateBanner
                        dataTestId="update-ms-fraud-defense-card"
                        providerIcon={
                            <MicrosoftIconNoBackground width={20} height={20} />
                        }
                        providerDisplayName={
                            microsoftProvider?.displayName || 'Microsoft'
                        }
                        isLoading={isMicrosoftFraudDefenseLoading}
                        onClick={handleMsUpdateClick}
                        buttonTestId="update-ms-fraud-defense-button"
                    />
                )}
                {shouldShowGoogleUpdateBanner && (
                    <IntegrationUpdateBanner
                        dataTestId="update-google-fraud-defense-card"
                        providerIcon={
                            <GoogleIconNoBackground width={20} height={20} />
                        }
                        providerDisplayName={
                            googleProvider?.displayName || 'Google'
                        }
                        isLoading={isGoogleFraudDefenseLoading}
                        onClick={handleGoogleUpdateClick}
                        buttonTestId="update-google-fraud-defense-button"
                    />
                )}
            </IntegrationSectionContainer>
        )
    }

    return (
        <IntegrationSectionContainer>
            <ProviderActivationCard
                icon={<MicrosoftIcon />}
                title="Activate Fraud Defense"
                subtitle="For Microsoft 365"
                onClick={handleMicrosoftIntegrationClick}
                isLoading={isMicrosoftFraudDefenseLoading}
                dataTestId="activate-ms-fraud-defense-card"
            />
            <ProviderActivationCard
                icon={<GoogleIcon />}
                title="Activate Fraud Defense"
                subtitle="For Google Workspace"
                onClick={handleGoogleIntegrationClick}
                isLoading={isGoogleFraudDefenseLoading}
                dataTestId="activate-google-fraud-defense-card"
            />
        </IntegrationSectionContainer>
    )
}

export default IntegrationSection
